import * as React from 'react';
import * as styles from './styles.css';
import cn from 'clsx';

import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { Tooltip, ArticleParagraph1, ArticleParagraph2, ArticleHeading4 } from '@cian/ui-kit';

import { ELeverOrderNameFront } from '../../../constants/leverOrder';

export interface IHonestProps {
  honestLevel: ELeverOrderNameFront;
  title: string;
}

export const Honest: React.FC<IHonestProps> = ({ honestLevel, title }) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={styles['container']}>
      <Tooltip
        theme="white"
        placement="bottom"
        title={
          <>
            <div className={styles['title']} data-testid="Honest-Tooltip-title">
              <ArticleHeading4>{title}</ArticleHeading4>
            </div>
            <a
              className={styles['link']}
              href="https://hc.cian.ru/hc/ru/articles/360061362792"
              target="_blank"
              rel="noreferrer"
            >
              <ConditionalWrapper
                if={isDesktop}
                ThenComponent={ArticleParagraph2}
                ElseComponent={ArticleParagraph1}
                color="accent-main-primary"
              >
                Участник программы «Работаю честно»
              </ConditionalWrapper>
            </a>
            <div className={styles['text']}>
              <ConditionalWrapper if={isDesktop} ThenComponent={ArticleParagraph2} ElseComponent={ArticleParagraph1}>
                Один из лучших специалистов Циан. Размещает только достоверные объявления и предоставляет качественне
                услуги.
              </ConditionalWrapper>
            </div>
          </>
        }
      >
        <div data-testid="Honest-icon" className={cn(styles['icon'], styles[`icon-${honestLevel}`])} />
      </Tooltip>
    </div>
  );
};

Honest.displayName = 'Honest';
